import React from 'react'
import '../Theme.css';
import './RadioButton.css';
import Text from "../text/Text";
import {WiMoonAltNew} from "react-icons/wi";

function RadioButton({style, text, checked, onClick}) {
    const className = "RadioButtonButton " + style;

    return (
        <button className={className} onClick={onClick}>
            <div className="RadioButton">
                <div className={"RadioButtonBox"}>
                    {(() => {
                        if (checked) {
                            return <WiMoonAltNew size={18} color={"#d1d4d7"}/>
                        }
                    })()}
                </div>
                <Text style={"RadioButtonText"} text={text}/>
            </div>
        </button>

    )
}

export default RadioButton;
